export default __webpack_public_path__ + "static/media/video.b6058497.svg";